import { render, staticRenderFns } from "./VehicleNonPublicInfo.vue?vue&type=template&id=b8a1d7fa&scoped=true&"
import script from "./VehicleNonPublicInfo.vue?vue&type=script&lang=ts&"
export * from "./VehicleNonPublicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleNonPublicInfo.vue?vue&type=style&index=0&id=b8a1d7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a1d7fa",
  null
  
)

export default component.exports